module.exports = __webpack_public_path__ + "assets/img/26_877.831ce860.jpg";